<template lang="pug">
  #app
    add-to-quote(:user="$root.currentUser")
    .scrim(v-if="$root.open" :class="$root.open ? 'active' : ''")
    .mity-quotes(:class="!$root.open ? 'closed' : ''")
      confirmation(v-if="$root.confirmation.open" :msg="$root.confirmation.msg" :returnState="$root.confirmation.returnState" :returnMsg="$root.confirmation.returnMsg")
      .loading(v-if="$root.currentUser.guest === null")
        p Loading ...
      .loaded(v-else :class="$root.confirmation.open ? 'hide' : ''")
        include template/header
        #mity-quotes-container.container
          section.guest-user(v-if="$root.currentUser.guest && !$root.activeDraft")
            auth

          .auth-user(v-else)
            nav
              include template/tabs
            section
              auth(v-if="$root.currentState == 'auth'")
              quotes(v-if="$root.currentState == 'quotes'")
              quote-viewer(v-if="$root.currentState == 'viewQuote'" :quote="$root.activeQuote")
              account(v-if="$root.currentState == 'account'")

              quote-cart(v-if="$root.activeDraft && $root.currentState == 'draft'" :quote="$root.activeDraft")

      include template/footer
      quote-full-view(v-if="!$root.currentUser.guest && $root.fullView" :quote="$root.activeQuote")
</template>

<script>
import connect from "./scripts/database.js";
import { Quotes } from "./scripts/quotes.js";
import Activity from "./scripts/activity.js";

export default {
  name: "MityQuotes",
  data() {
    return {
      screenHeight: 0,
      containerHeight: 0
    };
  },
  methods: {
    signOut: function() {
      connect.auth
        .signOut()
        .then(() => {
          if (
            sessionStorage.getItem("draft_quotes") &&
            sessionStorage.getItem("draft_quotes") !== "undefined"
          ) {
            this.$root.currentPage = "Log In";
            this.$root.currentState = "auth";
          } else {
            this.$root.currentPage = "Log In";
            this.$root.currentState = "quotes";
          }
        })
        .catch(function(error) {
          console.warn(error);
        });
    },
    toggleSlider() {
      this.$root.open = !this.$root.open;
    },
    getSize() {
      this.screenHeight = window.innerHeight;
      //container plus header & footer
      this.containerHeight =
        document.getElementById("mity-quotes-container").clientHeight + 150;
    },
    deleteQuote() {
      if (!this.$root.currentUser.guest) {
        let quoteDetails = this.$root.activeDraft;
        Quotes.deleteQuote(this.$root.activeDraft.id).then(() => {
          this.clearActiveQuotes();
        });

        Activity.userActivity(this.$root.currentUser, "request:delete", {
          quote: quoteDetails
        });
      } else {
        this.clearActiveQuotes();
      }
    },
    clearActiveQuotes() {
      this.$root.currentState = "quotes";
      this.$root.confirmation.open = false;
      this.$root.confirmation.confirm = false;
      this.$root.confirmation.processing = false;
      this.$root.activeDraft = "";
      sessionStorage.clear();
    },
    getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function(m, key, value) {
          vars[key] = value;
        }
      );
      return vars;
    }
  },
  mounted: function() {
    var self = this;

    //setting footer to fixed or not
    var checkExist = setInterval(function() {
      var element = document.getElementById("mity-quotes-container");
      if (element) {
        self.getSize();
        MutationObserver =
          window.MutationObserver || window.WebKitMutationObserver;

        var observer = new MutationObserver(function(mutations, observer) {
          self.getSize();
        });

        observer.observe(element, {
          subtree: true,
          attributes: true,
          childList: true,
          characterData: true
        });
        clearInterval(checkExist);
      }
    }, 100); // check every 100ms

    //checking for quote in url params
    var quoteSelect = this.getUrlVars()["viewQuote"];
    if (quoteSelect) {
      var timesRun = 0;
      this.toggleSlider();
      var checkQuoteExist = setInterval(function() {
        var button = document.getElementById(quoteSelect);
        if (button && !self.$root.currentUser.guest) {
          button.click();
          clearInterval(checkQuoteExist);
        }
        timesRun += 1;
        if (timesRun === 50) {
          console.log("quote " + quoteSelect + " not found");
          clearInterval(checkQuoteExist);
        }
      }, 100); // check every 100ms
    }
  },
  created: function() {
    var self = this;
    connect.auth.onAuthStateChanged(user => {
      if (user) {
        console.log("user signed in");
        if (user.displayName) {
          this.$root.currentUser.name = user.displayName;
        }
        this.$root.currentUser.guest = false;
        this.$root.currentUser.uid = user.uid;
      } else {
        console.log("user signed out");
        this.$root.currentUser.guest = true;
        this.$root.currentUser.name = "";
        this.$root.currentUser.uid = "";
      }
    });

    if (
      sessionStorage.getItem("draft_quotes") &&
      sessionStorage.getItem("draft_quotes") !== "undefined"
    ) {
      var session = JSON.parse(sessionStorage.getItem("draft_quotes"));
      this.$root.activeDraft = session;
      this.$root.currentState = "draft";
    }

    var elements = document.querySelectorAll("#open-cart");
    for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener("click", function() {
        self.toggleSlider();
      });
    }

    document.addEventListener("click", function(event) {
      if (
        event.target.classList.contains("scrim") &&
        event.target.classList.contains("active")
      ) {
        self.toggleSlider();
      }
    });
  }
};
</script>

<style lang="scss">
@import "./assets/styles/reset.scss";
@import "./assets/styles/variables.scss";

//GLOBALS

#app {
  font-size:16px;
  line-height: normal;
  .scrim {
    -moz-transition: background-color 0.5s ease-in-out;
    -o-transition: background-color 0.5s ease-in-out;
    -webkit-transition: background-color 0.5s ease-in-out;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    transition: background-color 0.5s ease-in-out;
    width: 100vw;
    z-index: 900;
    &.active {
      background: rgba(0, 0, 0, 0.6);
    }
  }
  .mity-quotes {
    background: #fff;
    border: 1px $border_gray solid;
    box-shadow: -1px 0px 10px -3px #070707;
    font-family: Gotham A, Gotham B, Arial, sans-serif;
    height: 100%;
    max-width: 375px;
    overflow: auto;
    position: fixed;
    right: 0;
    scroll-behavior: smooth;
    top: 0;
    transition: all 0.5s;
    width: 100%;
    z-index: 1000;
    &.closed {
      right: -400px;
    }

    *,
    *:before,
    *:after {
      box-sizing: border-box;
      outline: none;
    }

    a {
      color: $link_color;
      text-decoration: underline;
      &:hover {
        color: $link_hover;
      }
    }

    a,
    button {
      &:hover {
        cursor: pointer;
      }
    }

    strong,
    b {
      font-weight: bold;
    }

    em,
    i {
      font-style: italic;
    }

    h1 {
      font-size: 1.8em;
    }
    h2 {
      font-size: 1.5em;
      text-transform: none;
    }
    h3 {
      font-size: 1.3em;
      text-transform: none;
    }
    h4 {
      font-size: 1.1em;
      text-transform: none;
    }
    h5 {
      text-transform: none;
    }
    input {
      font-size: 14px;
    }

    .error {
      color: #f44336;
    }

    .loaded.hide {
      display: none;
    }
    header {
      align-items: center;
      background-color: $header_color;
      color: #fff;
      display: flex;
      justify-content: space-between;
      height: 100px;
      padding: 0 24px;
      button {
        background: transparent;
        border: none;
        color: #fff;
        padding: 0;
        width: auto;
        z-index: 100;
        svg {
          height: auto;
          width: 20px;
        }
      }
      button:hover {
        svg path {
          stroke: #ccc;
        }
      }
      h2 {
        font-size: 32px;
        font-weight: 500;
        span {
          color: #ccc;
          font-weight: 100;
        }
      }
    }
    nav {
      .tabs {
        background: $primary_color;
        display: flex;
        a {
          background: $primary_color;
          color: #fff;
          padding: 1em 0.5em;
          text-align: center;
          text-decoration: none;
          white-space: nowrap;
          width: 39%;
          svg {
            height: 20px;
            margin-right: 0.3em;
            vertical-align: sub;
            width: 20px;
          }
          &.active {
            background: $secondary_color;
          }
          &:hover {
            background: $secondary_color;
          }
        }
        @media only screen and (max-width: 375px) {
          a {
            width: 50%;
          }
        }
      }
    }
    section {
      h2 {
        font-size: 1.3em;
      }
      button {
        background-color: $button_color;
        border-radius: 5px;
        border: none;
        color: #fff;
        display: block;
        font-size: 14px;
        margin: 1em auto;
        padding: 1em 0;
        text-align:center;
        width: 50%;
        &:hover {
          background-color: $button_hover;
        }
      }
      button:disabled,
      button[disabled] {
        border: 1px solid #989898;
        background-color: #cdcdcd !important;
        color: #676767;
        cursor: default;
      }
    }
    .vdp-datepicker__calendar {
      border-radius: 8px;
      border: 2px solid $primary_color;
      margin: 1em auto 2em;
      width: 300px;
      div .cell {
        align-items: center;
        display: inline-flex;
        justify-content: center;
        vertical-align: middle;
        &.selected {
          background-color: $alert_yellow;
          border-radius: 20px;
        }
      }
      header {
        background-color: $primary_color;
        border-radius: 5px 5px 0 0;
        height: auto;
        padding: 0.8em;
        span {
          color: #fff;
          &.prev:after {
            border-right: 10px solid #fff;
          }
          &.next:after {
            border-left: 10px solid #fff;
          }
          &:hover {
            background: transparent;
            &.day__month_btn {
              color: $link_hover;
            }
            &.prev:after {
              border-right: 10px solid $link_hover;
            }
            &.next:after {
              border-left: 10px solid $link_hover;
            }
          }
        }
      }
    }
    footer {
      background: $light_gray;
      bottom: 0;
      color: $text_color;
      font-size: 0.9em;
      height: 50px;
      max-width: 375px;
      padding: 1em 2em;
      width: 100%;
      z-index: 2;
      &.fixed {
        position: fixed;
      }
      span.version {
        color: #000;
        float: right;
      }
      &.confirmation {
        background: #bcbcbc;
      }
    }
  }
}
</style>
